<div class="one" fxLayout="column" [formGroup]="matterFamliydetailForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.COHABITATIONDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.COHABITATIONDATE),
      }"
    >
      <mat-label>Cohabitation Date</mat-label>
      <input
        (dateInput)="CohabitationDateClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.COHABITATIONDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="COHABITATIONDATETEXT"
        (dateChange)="CohabitationDateClick('change', $event)"
        matInput
        [matDatepicker]="CohabitationDate"
      />
      <mat-datepicker-toggle matSuffix [for]="CohabitationDate"></mat-datepicker-toggle>
      <mat-datepicker #CohabitationDate></mat-datepicker>
      @if (testBool && toolTipList?.COHABITATIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.COHABITATIONDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.COHABITATIONDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.MARRIAGEDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MARRIAGEDATE),
      }"
    >
      <mat-label>Marriage Date</mat-label>
      <input
        (dateInput)="MarriageDateClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.MARRIAGEDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="MARRIAGEDATETEXT"
        (dateChange)="MarriageDateClick('change', $event)"
        matInput
        [matDatepicker]="MarriageDate"
      />
      <mat-datepicker-toggle matSuffix [for]="MarriageDate"></mat-datepicker-toggle>
      <mat-datepicker #MarriageDate></mat-datepicker>
      @if (testBool && toolTipList?.MARRIAGEDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.MARRIAGEDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.MARRIAGEDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.MARRIAGEPLACE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MARRIAGEPLACE),
      }"
    >
      <mat-label>Marriage Place</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.MARRIAGEPLACE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="MARRIAGEPLACE"
      />
      @if (testBool && toolTipList?.MARRIAGEPLACE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.MARRIAGEPLACE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.MARRIAGEPLACE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.MARRIAGECOUNTRY),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MARRIAGECOUNTRY),
      }"
    >
      <mat-label>Marriage Country</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.MARRIAGECOUNTRY?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="MARRIAGECOUNTRY"
      />
      @if (testBool && toolTipList?.MARRIAGECOUNTRY) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.MARRIAGECOUNTRY.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.MARRIAGECOUNTRY?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.SEPARATIONDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SEPARATIONDATE),
      }"
    >
      <mat-label>Separation Date</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.SEPARATIONDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="SEPARATIONDATE"
      />
      <!-- <input (dateInput)="SeparationDateClick('input', $event)" matTooltip="{{(toolTipList)?toolTipList.SEPARATIONDATETEXT:''}}"
                [matTooltipPosition]="toolTipPostion" formControlName="SEPARATIONDATETEXT" (dateChange)="SeparationDateClick('change', $event)" matInput [matDatepicker]="separationdate"> -->
      <!-- <mat-datepicker-toggle matSuffix [for]="separationdate"></mat-datepicker-toggle>
                <mat-datepicker #separationdate></mat-datepicker> -->
      @if (testBool && toolTipList?.SEPARATIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.SEPARATIONDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.SEPARATIONDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <!-- <mat-form-field appearance="outline" fxFlex="34" class="pr-1">
              <mat-label>Date Filed For Divorce</mat-label>
              <input matInput type="number" matTooltip="{{(toolTipList)?toolTipList.COURT:''}}"
                [matTooltipPosition]="toolTipPostion" formControlName="DATEFILEDFORDIVORCE">
                <div  *ngIf="testBool && toolTipList.LEGALAIDREFERENCE" class="tooltip-wrap" ><input id="myInput" readonly disabled value="{{(toolTipList)?toolTipList.LEGALAIDREFERENCE.COPYVALUE:''}}"><mat-icon (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.LEGALAIDREFERENCE?.COPYVALUE:'')">file_copy</mat-icon></div>
              </mat-form-field> -->

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DATEFILEDFORDIVORCE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATEFILEDFORDIVORCE),
      }"
    >
      <mat-label>Date Filed For Divorce</mat-label>
      <input
        (dateInput)="DateFiledForDivorceDateClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.DATEFILEDFORDIVORCE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DATEFILEDFORDIVORCETEXT"
        (dateChange)="DateFiledForDivorceDateClick('change', $event)"
        matInput
        [matDatepicker]="datefiledfordivore"
      />
      <mat-datepicker-toggle matSuffix [for]="datefiledfordivore"></mat-datepicker-toggle>
      <mat-datepicker #datefiledfordivore></mat-datepicker>
      @if (testBool && toolTipList?.DATEFILEDFORDIVORCE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.DATEFILEDFORDIVORCE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.DATEFILEDFORDIVORCE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DIVORCEDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DIVORCEDATE),
      }"
    >
      <mat-label>Divorce Date</mat-label>
      <input
        (dateInput)="DivorceDateClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.DIVORCEDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DIVORCEDATETEXT"
        (dateChange)="DivorceDateClick('change', $event)"
        matInput
        [matDatepicker]="DivorceDate"
      />
      <mat-datepicker-toggle matSuffix [for]="DivorceDate"></mat-datepicker-toggle>
      <mat-datepicker #DivorceDate></mat-datepicker>
      @if (testBool && toolTipList?.DIVORCEDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.DIVORCEDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DIVORCEDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DIVORCEPLACE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DIVORCEPLACE),
      }"
    >
      <mat-label>Divorce Place</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.DIVORCEPLACE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DIVORCEPLACE"
      />
      @if (testBool && toolTipList?.DIVORCEPLACE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.DIVORCEPLACE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DIVORCEPLACE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DIVORCECOUNTRY),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DIVORCECOUNTRY),
      }"
    >
      <mat-label>Divorce Country</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.DIVORCECOUNTRY?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DIVORCECOUNTRY"
      />
      @if (testBool && toolTipList?.DIVORCECOUNTRY) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.DIVORCECOUNTRY.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DIVORCECOUNTRY?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.NUMDEPENDANTS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.NUMDEPENDANTS),
      }"
    >
      <mat-label>Num Dependants</mat-label>
      <input
        matInput
        type="number"
        matTooltip="{{ toolTipList ? toolTipList?.NUMDEPENDANTS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="NUMDEPENDANTS"
      />
      @if (testBool && toolTipList?.NUMDEPENDANTS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.NUMDEPENDANTS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.NUMDEPENDANTS?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <!--
                        <mat-form-field appearance="outline" fxFlex="33" class="pr-1" [ngClass]="{'has-error':errorWarningData.Error?.MatterNo,'has-warning':errorWarningData.Warning?.MatterNo}">
                          <mat-label>Court Matter #</mat-label>
                          <input matInput matTooltip="{{(toolTipList)?toolTipList.COURT:''}}"
                            [matTooltipPosition]="toolTipPostion" formControlName="MatterNo">
                            <div  *ngIf="testBool && toolTipList.LEGALAIDREFERENCE" class="tooltip-wrap" ><input id="myInput" readonly disabled value="{{(toolTipList)?toolTipList.LEGALAIDREFERENCE.COPYVALUE:''}}"><mat-icon (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.LEGALAIDREFERENCE?.COPYVALUE:'')">file_copy</mat-icon></div>
                          </mat-form-field> -->

    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.FAMILYCOURTCLIENTID),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FAMILYCOURTCLIENTID),
      }"
    >
      <mat-label>Family Court Client ID</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.FAMILYCOURTCLIENTID?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="FAMILYCOURTCLIENTID"
      />
      @if (testBool && toolTipList?.FAMILYCOURTCLIENTID) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.FAMILYCOURTCLIENTID.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.FAMILYCOURTCLIENTID?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ExpirationDate),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ExpirationDate),
      }"
    >
      <mat-label>Expiry Date</mat-label>
      <input
        (dateInput)="ExpiryDateClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.EXPIRATIONDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ExpirationDatetextF"
        (dateChange)="ExpiryDateClick('change', $event)"
        matInput
        name="ExpiryDate"
        [matDatepicker]="ExpiryDate"
      />
      <mat-datepicker-toggle matSuffix [for]="ExpiryDate"></mat-datepicker-toggle>
      <mat-datepicker #ExpiryDate></mat-datepicker>
      @if (testBool && toolTipList?.EXPIRATIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.EXPIRATIONDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.EXPIRATIONDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <!-- <mat-form-field appearance="outline" fxFlex="50" class="pr-1" [ngClass]="{'has-error':errorWarningData.Error?.EXPERTHEARINGDATE,'has-warning':errorWarningData.Warning?.EXPERTHEARINGDATE}">
                              <mat-label>Hearing Date</mat-label>
                              <input (dateInput)="HearingDateClick('input', $event)" matTooltip="{{(toolTipList)?toolTipList.COURT:''}}"
                                [matTooltipPosition]="toolTipPostion" formControlName="EXPERTHEARINGDATE" (dateChange)="HearingDateClick('change', $event)" matInput [matDatepicker]="HearingDate">
                                <mat-datepicker-toggle matSuffix [for]="HearingDate"></mat-datepicker-toggle>
                                <mat-datepicker #HearingDate></mat-datepicker>
                                <div  *ngIf="testBool && toolTipList.COURT" class="tooltip-wrap" ><input id="myInput" readonly disabled value="{{(toolTipList)?toolTipList.COURT.COPYVALUE:''}}"><mat-icon (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.COURT?.COPYVALUE:'')">file_copy</mat-icon></div>
                              </mat-form-field> -->
  </div>
</div>
